<template>
    <div>
        <h3>Rating List &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form
            class="el_head_search"
            ref="form"
            :model="form"
            label-width="80px"
        >
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Prompt" prop="prompt">
                        <el-input v-model="form.prompt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="最高分" prop="max_score">
                        <el-input v-model="form.max_score"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="最低分" prop="min_score">
                        <el-input v-model="form.min_score"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="是否创建" prop="is_created">
                        <el-select
                            v-model="form.is_created"
                            placeholder="请选择"
                        >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户名" prop="user">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search"
                        >搜索</el-button
                    >
                    <el-button type="primary" size="small" @click="resetForm"
                        >重置</el-button
                    >
                </el-col>
            </el-row>
        </el-form>

        <el-table
            v-loading="tableLoad"
            :data="tableData"
            border
            style="width: 100%"
        >
            <el-table-column label="Prompt">
                <template slot-scope="scope">
                    {{ scope.row.prompt }}
                </template>
            </el-table-column>
            <el-table-column label="评分" width="100" align="center">
                <template slot-scope="scope">
                    {{ scope.row.score.TotalScore }}
                </template>
            </el-table-column>
            <el-table-column label="是否创建Prompt" width="150" align="center">
                <template slot-scope="scope">
                    {{
                        Number(scope.row.is_created_prompt) === 1 ? "是" : "否"
                    }}
                </template>
            </el-table-column>
            <el-table-column label="用户" width="150" align="center">
                <template slot-scope="scope">
                    {{
                        scope.row.author_info
                            ? scope.row.author_info.name
                            : "--"
                    }}
                </template>
            </el-table-column>
            <el-table-column label="评分时间(UTC)" width="150" align="center">
                <template slot-scope="scope">
                    {{
                        $moment(
                            new Date(scope.row.created_at).getTime()
                        ).utc().format("YYYY-MM-DD HH:mm:ss")
                    }}
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination
                background
                :hide-on-single-page="true"
                layout="prev, pager, next"
                :page-size="params.size"
                :current-page="params.page"
                :total="total"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import serverApi from "../../server/index";
export default {
    name: "rating",
    data() {
        return {
            sum: 0,
            form: {
                prompt: "",
                max_score: "",
                min_score: "",
                is_created: "",
                user: "",
            },
            tableData: [],
            tableLoad: false,
            multipleData: [],
            deleteLoad: false,
            searchValue: "",
            params: {
                size: 10,
                page: 1,
            },
            total: 0,
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData(_params) {
            this.tableLoad = true;
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.getPromptRating(params);

                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: "error",
                });
            } finally {
                this.tableLoad = false;
            }
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },
        handleCurrentChange(val) {
            this.params.page = val;
            this.initData();
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}

h4 {
    margin-bottom: 30px;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.demo-input-suffix {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
</style>
